import { getSrcs } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import * as React from 'react';
import Modal from '../Modal/Modal';
import S from './ModalGallery.styles';
import { useModalGalleryContext } from './ModalGalleryProvider/ModalGalleryProvider';
const ModalGallery = (props) => {
    const { media, openIndex, ...rest } = props;
    const [startingX, setStartingX] = React.useState(0);
    const modalGallery = useModalGalleryContext();
    const activeItem = media != undefined && media[modalGallery.activeIndex];
    React.useEffect(() => {
        if (openIndex !== modalGallery.activeIndex) {
            modalGallery.goToIndex(openIndex);
        }
    }, [openIndex]);
    if (!activeItem) {
        return null;
    }
    const srcs = getSrcs(activeItem, 1920, 284, 12);
    return (React.createElement(Modal, { ...rest },
        React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: activeItem.altText ?? undefined, role: !activeItem.altText ? 'presentation' : undefined }),
        React.createElement(S.DragContainer, { draggable: true, onTouchStart: (event) => {
                setStartingX(event.targetTouches[0].clientX);
            }, onTouchEnd: (event) => {
                const endingX = event.changedTouches[0].clientX;
                if (endingX < startingX) {
                    modalGallery.goToNext(false);
                }
                else {
                    modalGallery.goToPrev(false);
                }
            } }),
        media.length > 1 && (React.createElement(React.Fragment, null,
            React.createElement(S.ControlButton, { "aria-label": "Previous", disabled: modalGallery.activeIndex === 0, type: "button", "data-variant": "prev", onClick: (event) => {
                    event.preventDefault();
                    modalGallery.goToPrev(false);
                } }, getSvgFromSystem(SystemIcon.HoverArrowRight)),
            React.createElement(S.ControlButton, { "aria-label": "Next", disabled: modalGallery.activeIndex === modalGallery.maxIndex, type: "button", "data-variant": "next", onClick: (event) => {
                    event.preventDefault();
                    modalGallery.goToNext(false);
                } }, getSvgFromSystem(SystemIcon.HoverArrowRight))))));
};
export default ModalGallery;
